import { render, staticRenderFns } from "./fccResponsavel.vue?vue&type=template&id=75120b92"
import script from "./fccResponsavel.vue?vue&type=script&lang=js"
export * from "./fccResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports